<template>
    <g fill="" fill-rule="evenodd">
        <g>
            <g>
                <g transform="translate(-39 -44) translate(39 44)">
                    <rect width="55" height="24" fill="#13C7C8" rx="12"/>
                    <circle cx="43" cy="12" r="7" fill="#FFF"/>
                </g>
                <text fill="#FFF" font-family="OpenSans-Bold, Open Sans" font-size="11" font-weight="bold" transform="translate(-39 -44) translate(39 44)">
                    <tspan x="10" y="16">Live</tspan>
                </text>
            </g>
        </g>
    </g>
</template>

<script>
export default {
    name: 'switcherLiveAdUnitIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 55 24');
    }
};
</script>
